export default {
  apiKey: "AIzaSyBhgfrVCBSgzRtPpm-2wvWmaH0glgct95Q",
  authDomain: "alocal-499e3.firebaseapp.com",
  databaseURL: "https://alocal-499e3-default-rtdb.firebaseio.com",
  projectId: "alocal-499e3",
  storageBucket: "alocal-499e3.appspot.com",
  messagingSenderId: "939303005785",
  appId: "1:939303005785:web:c24924bb22fff2634d0b48"
};
